import { computed } from 'vue';
import { useCheckoutStore } from '../stores/checkout.ts';
import { Checkout, Util } from '@vp/common';

export function useSelectedEvent() {
  const checkoutStore = useCheckoutStore();

  const event = computed<Checkout.CheckoutEvent.CheckoutEvent | undefined>(() => checkoutStore.selectedEvent);

  const isLoading = computed(() => checkoutStore.selectedEventLoadingState === Util.LoadingState.LOADING);

  return {
    event,
    isLoading,
  };
}
